export const APP_COLORS = {
  PRIMARY_COLOR: {
    color: "#13292A", //13292A
    dark: "#13292A",
    light: "#767687",
  },
  PRIMARY_LIGHT_COLOR: {
    color: "#A3BB98",
  },
  SECONDARY_COLOR: {
    color: "#FFB100", //D8C3A5 847555
  },
  TERTIARY_COLOR: {
    color: "#E7DED9",
  },
  TERTIARY_LIGHT_COLOR: {
    color: "#FFFBF8",
  },
  WHITE_COLOR: {
    color: "#FFF",
  },

  LIGHT_COLOR: {
    color: "#F8F8F8",
  },
  BLACK_LIGHT_COLOR: {
    color: "#242424",
  },
  YELLOW_COLOR: {
    color: "#FFB100", ////pink E58853 //255, 195, 0
  },
  ORANGE_COLOR: {
    color: "#FA9951",
  },
  PINK_COLOR: {
    color: "#E58853",
  },
  BLUE_COLOR: {
    color: "#188CD7",
  },
  GREEN_COLOR: {
    color: "#72E2BE",
  },
  RED_COLOR: {
    color: "#bd5d7c", //#B22222
  },
  GRAY_COLOR: {
    color: "#EBEBEB",
  },
  YELLOW_COLOR_TRANSPARENT: {
    color: "rgba(255, 177, 0, 0.3)",
  },
  PRIMARY_COLOR_TRANSPARENT: {
    color: "rgba(47, 52, 91, 0.5)",
  },
  RED_TRANSPARENT_COLOR: {
    color: "rgba(231, 64, 32, 0.5)",
  },
  BLUE_TRANSPARENT_COLOR: {
    color: "rgba(24, 140, 215, 0.5)",
  },
  GREEN_TRANSPARENT_COLOR: {
    color: "rgba(114, 226, 190, 0.5)",
  },
};
